export const FETCH_USER_PERSONAL_CCR_DATA_REQUEST = 'FETCH_USER_PERSONAL_CCR_DATA_REQUEST'
export const FETCH_USER_PERSONAL_CCR_DATA_SUCCESS = 'FETCH_USER_PERSONAL_CCR_DATA_SUCCESS'
export const FETCH_USER_PERSONAL_CCR_DATA_ERROR = 'FETCH_USER_PERSONAL_CCR_DATA_ERROR'

export const FETCH_BANK_INFORMATION_REQUEST = 'FETCH_BANK_INFORMATION_REQUEST'
export const FETCH_UPDATE_BANK_INFORMATION_SUCCESS = 'FETCH_UPDATE_BANK_INFORMATION_SUCCESS'
export const FETCH_UPDATE_BANK_INFORMATION_ERROR = 'FETCH_UPDATE_BANK_INFORMATION_ERROR'

export const FETCH_USER_INFORMATION_REQUEST = 'FETCH_USER_INFORMATION_REQUEST'
export const FETCH_UPDATE_USER_INFORMATION_SUCCESS = 'FETCH_UPDATE_USER_INFORMATION_SUCCESS'
export const FETCH_UPDATE_USER_INFORMATION_ERROR = 'FETCH_UPDATE_USER_INFORMATION_ERROR'

export const GENERATE_USER_CCR_REQUEST = 'GENERATE_USER_CCR_REQUEST'
export const GENERATE_USER_CCR_SUCCESS = 'GENERATE_USER_CCR_SUCCESS'
export const GENERATE_USER_CCR_ERROR = 'GENERATE_USER_CCR_ERROR'

export const FETCH_USER_CCR_REQUEST = 'FETCH_USER_CCR_REQUEST'
export const FETCH_USER_CCR_SUCCESS = 'FETCH_USER_CCR_SUCCESS'
export const FETCH_USER_CCR_ERROR = 'FETCH_USER_CCR_ERROR'
export const FETCH_CLEAN_USER_CCR_DATA = 'FETCH_CLEAN_USER_CCR_DATA'

export const SIGN_USER_CCR_REQUEST = 'SIGN_USER_CCR_REQUEST'
export const SIGN_USER_CCR_SUCCESS = 'SIGN_USER_CCR_SUCCESS'
export const SIGN_USER_CCR_ERROR = 'SIGN_USER_CCR_ERROR'

export const CCR_ERROR = 'CCR_ERROR'
